import '@/styles/main.scss'
import '@/registerServiceWorker'

import Vue from 'vue'

import vuetify from '@/plugins/vuetify'

import App from '@/App.vue'
import router from '@/router'
import { store } from '@/store'
import { date } from '@/filters/date'

Vue.filter('date', date)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
